import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page48',
  templateUrl: './page48.component.html',
  styleUrls: ['./page48.component.css']
})
export class Page48Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
